// src/pages/Infrastructure.jsx
import React from "react";
import innerBanner from "../Images/inner-banner-image.jpg";
import Footer from "../Components/Footer";
import infrastructureImage from "../Images/infra-page-image.png";
import SFPimage from "../Images/Soft-packaging-machine.png";
import hydroExtractor from "../Images/hydro-extractor-image.png";
import rfDryer from "../Images/RF dryer.png";

const Infrastructure = () => {
  return (
    <div>
      <div className="inner-banner-section">
        <img src={innerBanner} alt="inner-banner" />
        <div className="inner-banner-heading">
          <span>Infrastructure</span>
        </div>
      </div>
      {/* --------------------------------------------- */}

      <div className="infra-sec-1">
        <div className="container">
          <div className="infra-sec-1-cont">
            <h1>Our Plant and Technology</h1>
            <p>
              The selection of machineries for this Quality work was done with
              utmost care and with least compromise. We believe in technological
              advancements in the industry, therefore keep upgrading our
              machinery set up to meet the demands of the market and to create
              suitable working environment for its employee. SSM cheese winding
              machine imported from swiss, is a mark of our upgradation as an
              example.
            </p>
            <div className="infra-sec-1-cont-section">
              <div className="infra-sec-1-left">
                <h3>Dyeing Machines</h3>
                <p>
                  Fully automated HTHP yarn dyeing machines manufactured by M/s
                  Fongs China and Dalal Engineering India, as per the capacities
                  mentioned have been installed.
                </p>
                <div class="table_component" role="region" tabindex="0">
                  <table>
                    <thead>
                      <tr>
                        <th>Machine Capacity</th>
                        <th>Lot Size</th>
                        <th>Make</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>1170 kg</td>
                        <td>1050-1170</td>
                        <td>Fongs</td>
                      </tr>
                      <tr>
                        <td>780 Κg</td>
                        <td>650-780</td>
                        <td>Fongs</td>
                      </tr>
                      <tr>
                        <td>400 Kg x 2</td>
                        <td>430-400</td>
                        <td>Dalal</td>
                      </tr>
                      <tr>
                        <td>200 Kg</td>
                        <td>230-200</td>
                        <td>Daial</td>
                      </tr>
                      <tr>
                        <td>150 Kg</td>
                        <td>130-150</td>
                        <td>Fongs</td>
                      </tr>
                      <tr>
                        <td>100 Kg</td>
                        <td>90-110</td>
                        <td>Dalal</td>
                      </tr>
                      <tr>
                        <td>60 Kg</td>
                        <td>50-60</td>
                        <td>Fongs</td>
                      </tr>
                      <tr>
                        <td>25 Kg</td>
                        <td>20-25</td>
                        <td>RK</td>
                      </tr>
                      <tr>
                        <td>30 Kg</td>
                        <td>25-30</td>
                        <td>RK</td>
                      </tr>
                      <tr>
                        <td>7 Kg</td>
                        <td>6-7</td>
                        <td>Fongs</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              <div className="infra-sec-1-right">
                <div className="infra-sec-1-img">
                  <img src={infrastructureImage} alt="Infrastructure" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* ----------------------------------------------- */}

      <div className="infra-sec-2">
        <div className="container">
          <div className="infra-sec-2-cont">
            <div className="infra-sec-2-left"></div>
            <div className="infra-sec-2-right">
              <h3>Rewinding Machines</h3>
              <span>(Capacity: 10000kg/Day)</span>
              <p>
                The Yarn may be best dyed but its performance is complete when
                the cone winding is done with adequate requirements to meet the
                knitting, warping and weaving performance. knowing this fact
                well, we have installed cone winding machines with individually
                driven motor from SMEW Filcona, Ahemedabad. We are also
                continuously upgrading the machines with new technology.
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* ------------------------------------------------ */}

      <div className="quality-section-2">
        <div className="container">
          <div className="quality-section-2-cont">
            <div className="quality-section-2-left">
              <h2>
                Soft Package Machine <br /> <span>(Capacity: 10000kg/Day)</span>
              </h2>

              <p>
                True to the statement that well wound is half dyed, therefore we
                believe in upgrading the winding technology. In the process, the
                new addition is SSM Cheese Winding Machines from Switzerland.
              </p>
              <p>
                Our capacity right now about 6000 kg from SSM and 4000 kg from
                SMEW Filcona, Ahmedabad.
              </p>
            </div>
            <div className="quality-section-2-right">
              <div className="quality-sec-2-img">
                <img src={SFPimage} alt="Quality-image" />
                <div className="quality-add-content"></div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* -------------------------------------------- */}

      <div className="infra-sec-3">
        <div className="container">
          <div className="infra-sec-3-cont">
            <div className="infra-sec-3-left">
              <div class="grid">
                <figure
                  class="effect-sadie infra-sec"
                  data-aos="fade-up"
                  data-aos-duration="1000"
                >
                  <img src={hydroExtractor} alt="cotton" />
                  <figcaption>
                    <h2>
                      <span>Hydro Extractor</span>
                    </h2>

                    <p>
                      <b>Capacity 11000 kg/Day</b>
                      <br />2 units of twin lobe Hydro Extractors from M/S Laxmi
                      Card Clothing - Coimbatore & Monga Stay Field from Pune,
                      to the capacity of 11 Ton per day.
                    </p>
                  </figcaption>
                </figure>
              </div>
            </div>
            <div className="infra-sec-right">
              <div className="grid">
                <figure
                  class="effect-sadie infra-sec"
                  data-aos="fade-up"
                  data-aos-duration="1000"
                >
                  <img src={rfDryer} alt="cotton" />
                  <figcaption>
                    <h2>
                      <span>Radio Frequency Dryer</span>
                    </h2>

                    <p>
                      <b>Capacity 85 Kw 4000kg/Day</b>
                      <br />
                      The best available technology in this field is chosen
                      keeping in mind the final quality of the product and the
                      supplier is M/s Monga Strayfield, Pune, India.
                    </p>
                  </figcaption>
                </figure>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* -------------------------------------------- */}

      <div className="infra-sec-4">
        <div className="containers">
          <div className="infra-sec-4-cont">
            <div className="infra-sec-4-left">
              <h3>Effluent treatment Plant</h3>
              <p>
                The plant operates on Zero Liquid Discharge principle fully
                meeting the norms of Tamil Nadu Pollution Control Board.
              </p>
              <div className="infra-sec-4-left-cont">
                <h4>What we do</h4>
                <p>
                  Dye-bath Effluent of the factory is treated by the
                  Electrolysis Method whereas Coagulation and Biological Method
                  for the Wash Water Effluent. We ensure recovery of Salt that
                  we use in the dye-bath exhaustion through Nano-Filtration
                  Membrane for re-use. And about 93% recovery of wash water back
                  to the process on daily basis with all the technical
                  parameters taken care making it 100% suitable for quality
                  dyeing.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* -------------------------------------------- */}

      <Footer />
    </div>
  );
};

export default Infrastructure;
